// extracted by mini-css-extract-plugin
export default {"cartContainer":"ShoppingCart_cartContainer__HTgca"};